module.exports = __webpack_public_path__ + "olr-mainfe/styles/bootstrap/fonts/glyphicons-halflings-regular.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./src/olr-mainfe/styles/bootstrap/fonts/glyphicons-halflings-regular.woff2
 ** module id = 43
 ** module chunks = 1
 **/